import React from "react";
import { Col, Row } from "antd";
import Auxiliary from "util/Auxiliary";
import { zoomConnect } from 'util/config'
import * as QueryString from "query-string"
import CircularProgress from "components/CircularProgress";
import useGoogleConnect from '../../../../hooks/connect/useGoogleConnect'

const Google = (props) => {
  const { code } = QueryString.parse(props.location.search);
  const { status, isLoading } = useGoogleConnect(code);
  return (
    <Auxiliary>
      {isLoading && <div className="gx-loader-view ant-modal-mask">
        <CircularProgress className='gx-h1-lg' />
      </div>}
      {status === 'success' && <h2>Successfully added the Google Calendar app.</h2>}
    </Auxiliary>
  );
};

export default Google;
